import { useEffect, useState, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Loader2, AlertCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

// Rückkehr-Magic-Link: setzt eine unterbrochene Demo per Token fort (Cookie-Verlust).
export default function GuestResume() {
  const { token } = useParams();
  const navigate = useNavigate();
  const { resumeGuest } = useAuth();
  const [error, setError] = useState(false);
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    (async () => {
      try {
        await resumeGuest(token);
        navigate("/dashboard", { replace: true });
      } catch {
        setError(true);
      }
    })();
  }, [token, resumeGuest, navigate]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-slate-50 px-4" data-testid="guest-resume">
      {error ? (
        <div className="max-w-md w-full text-center rounded-2xl border border-slate-200 bg-white p-8 shadow-sm">
          <div className="mx-auto w-12 h-12 rounded-full bg-red-50 flex items-center justify-center mb-4">
            <AlertCircle className="h-6 w-6 text-red-500" />
          </div>
          <h1 className="font-heading text-xl font-bold text-slate-900">Demo nicht gefunden</h1>
          <p className="mt-2 text-slate-600">
            Diese Demo-Sitzung ist abgelaufen oder wurde bereits in ein Konto umgewandelt.
            Du kannst jederzeit eine neue Demo starten.
          </p>
          <Button
            onClick={() => navigate("/", { replace: true })}
            className="mt-6 bg-emerald-600 hover:bg-emerald-700 text-white"
            data-testid="guest-resume-restart"
          >
            Neue Demo starten
          </Button>
        </div>
      ) : (
        <div className="text-center text-slate-500">
          <Loader2 className="h-8 w-8 animate-spin mx-auto mb-3 text-emerald-600" />
          <p>Deine Demo wird fortgesetzt …</p>
        </div>
      )}
    </div>
  );
}
